/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
// Temporarily comment out Sass import due to node-sass compatibility issues
// import "./src/sass/waveImaging.scss"

// Import CSS files in order
import "./src/styles/reset.css"
import "./src/styles/normalize-overrides.css"
import "./src/styles/main.css"
import "./src/styles/bulma.css"
import "./src/fonts/fontawesome/css/all.min.css"
import "./src/styles/additional.css"
import "./src/styles/browser-fixes.css"